import React from "react";
import { Button, Card, Divider, message, Table } from 'antd';
import PropTypes from 'prop-types';
import styles from '../index.css'
import NHFetch from "../../../utils/NHFetch";
import { getLoginUser } from "../../../utils/NHCore";
import getSize from '../../../utils/getSize';
import { NHConfirm } from '../../common/NHModal';

const hjdm = "GD006_2";   //环节代码
const basicUrl = 'api/zhxg-yxxt/yxxc/';

/**
 * @author liudongbin
 * @date 2021/9/28
 * @time 9:06
 * @Description: 迎新现场-现场分班
 */
class AhgsXcfb extends React.Component {
    constructor() {
        super();
        this.state = {
            id: '1',
            stuxy: '',            //学院
            stuzy: '',            //专业
            bjlist: [],           //班级列表
            bjlistbk: [],         //班级列表备份
            selectbjid: '',       //选择的班级ID
            selectbjmc: '',       //选择的班级名称
            scrollHeight: 200,    //默认滚动高度
            zdblLoading:false ,
            loading:false,
            selectedRowKeys: [],
        }
    }

    componentWillMount() {
        let that = this;
        this.setState({ scrollHeight: getSize().windowH - 206 });
        window.onresize = function () {
            that.setState({
                scrollHeight: getSize().windowH - 206,
            })
        }
    }

    componentDidMount() {
        let { xsid, bjid } = this.props.studentData;
        if (xsid) {
            //加载学生信息、学生可选班级数据
            this.getBjOptionList(xsid);

            // 设置学生班级名称  学院  专业
            this.setState({ selectbjmc: this.props.studentData.bjmc, stuxy: this.props.studentData.bmmc, stuzy: this.props.studentData.zymc, selectbjid:bjid})

            const selectedRowKeys = [];
            selectedRowKeys.push(bjid);
            if(this.state.selectedRowKeys.length == 0){
                this.setState({ selectedRowKeys:selectedRowKeys} )
            }
            return true;
        }
    }

    componentWillReceiveProps(nextProps) {
        //环节办理状态
        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (hjblztData) {
                let editable = hjblztData.blzt !== '1';
                this.setState({ editable: editable });
            } else {
                this.setState({ editable: true });
            }
        }

        //学生数据
        if ('studentData' in nextProps) {
            const newStudentData = nextProps.studentData;
            const oldStudentData = this.props.studentData;
            //避免多次请求
            if ((Object.keys(newStudentData).length !== 0 && Object.keys(oldStudentData).length === 0) ||
                (Object.keys(newStudentData).length !== 0 && Object.keys(oldStudentData).length !== 0
                    && oldStudentData.xsid !== newStudentData.xsid)) {
                const { xsid } = newStudentData;
                if (xsid) {
                    //加载学生信息、可选班级数据
                    //this.getBjOptionList(xsid);
                    return true;
                }
            }
        }
    }

    //获取学生可选班级数据
    getBjOptionList = (xsid) => {
        NHFetch(basicUrl + "selectBjOptionListByXsid", 'GET', {xsid: xsid ? xsid : ""})
            .then(res => {
                if(res){
                    const data = res.data;
                    this.setState({
                        // 若查不到班级数据，接口返回为空数据，学院 专业数据改为显示父页面的数据
                        // stuxy: data[0].xy,
                        // stuzy: data[0].zy,
                        bjlist: data[0].bjlist,
                        bjlistbk: data[0].bjlist
                    });
                }
            })
    }

    //确定办理提交
    handleSubmit = () => {
        const { xsid } = this.props.studentData;
        const { pkid } = this.props.hjblztData;
        const selectbjid = this.state.selectbjid;
        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }
        if(!selectbjid){
            message.error("环节办理失败,请先选择班级！");
            return;
        }

        this.setState({ loading: true });
        let userId = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, lchjid: pkid, hjdm: hjdm,yhbh:userId,formData: { bjid: selectbjid, xsid: xsid } }
        this.updateBJInfoToXsid(params, xsid);
        this.setState({ loading: false })

    };

    // 办理分班环节
    updateBJInfoToXsid = (params,xsid) => {
        NHFetch(basicUrl + 'updateBJInfoToXsid', 'POST', params)
            .then(res => {
                if(res){
                    if(res.data === 1){
                        message.success('环节办理成功！');
                        this.getBjOptionList(xsid);
                        this.setState({
                            editable: false
                        })

                        //办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('submit');
                        }
                    }else{
                        message.error('环节办理失败，请重试！');
                    }
                    this.setState({ loading: false })
                } else {
                    message.error('环节办理失败，请重试！');
                    this.setState({ loading: false })
                }
            }).catch(() => {
            message.error('环节办理失败，请重试！');
            this.setState({ loading: false })
        })
    }

    //取消办理提交
    handleCancel = () => {
        const { pkid } = this.props.hjblztData;
        const { xsid } = this.props.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, lchjid: pkid, hjdm: hjdm, bjid: '',yhbh:userId };

        NHConfirm("是否确定取消办理？",() => {
            this.setState({ loading: true });
            NHFetch(basicUrl + 'clearBJInfoByXsid', 'POST', params)
                .then(res => {
                    if (res && res.data === 1) {
                        message.success('环节办理取消成功！');
                        // 重新获取可选班级列表
                        this.getBjOptionList(xsid);

                        this.setState({
                            editable: true,
                            selectbjid: '',
                            selectbjmc: '',
                            selectedRowKeys: []
                        });

                        //取消办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('cancel');
                        }
                    } else {
                        message.error('环节办理取消失败，请重试！');
                    }
                    this.setState({ loading: false });
                }).catch(() => {
                message.error("环节办理取消失败，请重试！");
                this.setState({ loading: false });
            });
        },"warn");
    };

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        const { onLast } = this.props;
        if (onLast) {
            onLast();
        }
    };

    //下一步
    handleNext = () => {
        const { onNext } = this.props;
        if (onNext) {
            onNext();
        }
    };

    render() {
        const { editable, bjlist,loading,selectedRowKeys } = this.state;
        const { xsid } = this.props.studentData;
        const { lchjData = {}, hasLast, hasNext } = this.props;
        // 可选择班级表头
        const columns = [
            {
                title: '班级名称',
                dataIndex: 'bjmc',
                align: 'center',
                width: '22.5%'
            },
            {
                title: '已分配人数',
                dataIndex: 'yfprs',
                align: 'center',
                width: '22.5%'
            },
            {
                title: '男生',
                dataIndex: 'malers',
                align: 'center',
                width: '22.5%'
            },
            {
                title: '女生',
                dataIndex: 'femalers',
                align: 'center',
                width: '22.5%'
            }
        ]

        const { sfdybdd = '0' } = lchjData; //是否打印报到单
        const rowSelection = {
            type: 'radio',
            columnTitle: "选择",
            columnWidth: '10%',
            selectedRowKeys,

            onChange: (selectedRowKeys,selectedRows) => {
                this.setState({
                    selectbjid: selectedRows[0].bjid,
                    selectbjmc: selectedRows[0].bjmc,
                    selectedRowKeys
                })
                const bjlistbk = [...this.state.bjlistbk];
                const fsex = this.props.studentData.xb;
                //如果选中的班级不是当前学生的班级，则 增加班级已分配人数
                if( (selectedRows[0].bjid)!=this.props.studentData.bjmc){
                    this.setState({
                        bjlist: bjlistbk.map(
                            (item,index) => {
                                if(item.bjid === selectedRows[0].bjid && fsex === '女'){
                                    return {...item,yfprs: parseInt(item.yfprs)+1,femalers: parseInt(item.femalers)+1}
                                }else if(item.bjid === selectedRows[0].bjid && fsex === '男'){
                                    return  {...item,yfprs: parseInt(item.yfprs)+1,malers: parseInt(item.malers)+1}
                                }else if(item.bjid === selectedRows[0].bjid){
                                    return  {...item,yfprs: parseInt(item.yfprs)+1}
                                }else{
                                    return item
                                }
                            }
                        )
                    })
                }
            },
            getCheckboxProps: record => ({
                disabled: editable === false,
                name: record.name,
            })
        }

        const rowClassName = (record,index) => {
            return record.bjid === this.state.selectbjid || record.bjid === this.props.studentData.bjid  ? styles.bjselected : '';
        }
        return (
            <div>
                <Card type="inner" title="现场分班业务信息">
                    {
                        !xsid ? <div /> : editable ?
                            <div>
                                <div style={{ fontWeight: 'bolder', marginBottom: '20px', color: '#262626' }}
                                     className={styles.xcfbtbl}
                                >
                                    {this.state.stuxy}-{this.state.stuzy}
                                </div>
                                <Table
                                    columns={columns}
                                    dataSource={bjlist}
                                    pagination={false}
                                    rowSelection={rowSelection}
                                    rowClassName={rowClassName}
                                    rowKey="bjid"
                                    style={{ width: '90%', margin: '0px 40px' }}
                                />
                            </div> :
                            <div>
                                <div style={{ fontWeight: 'bolder', marginBottom: '20px', color: '#262626' }}
                                     className={styles.xcfbtbl}
                                >
                                    {this.state.stuxy}-{this.state.stuzy}-{this.state.selectbjmc}
                                </div>
                                <Table
                                    columns={columns}
                                    dataSource={bjlist}
                                    pagination={false}
                                    rowSelection={rowSelection}
                                    rowClassName={rowClassName}
                                    rowKey="bjid"
                                    style={{ width: '90%', margin: '0px 40px' }}
                                />
                            </div>

                    }

                </Card>

                <Divider style={{ margin: '40px 0 24px' }} />
                {editable ? <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button> :
                    <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>}

                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast && <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button>
                }
                {
                    hasNext && <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button>
                }

                <style jsx="true" global="true">
                    {`
                        .ant-table-tbody>tr>td {
                            border-bottom: 1px solid #e8e8e8 !important;
                        }
                    `}
                </style>
            </div>
        )
    }
}

AhgsXcfb.propTypes = {
    studentData: PropTypes.object,  //学生信息
    hjblztData: PropTypes.object,   //环节办理状态数据
    hjywxData: PropTypes.array,     //环节业务项数据
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool,        //是否有上一个环节
    hasNext: PropTypes.bool,        //是否有下一个环节
    onLast: PropTypes.func,         //上一步操作回调
    onNext: PropTypes.func,         //下一步操作回调
    onFinish: PropTypes.func,       //环节办理完成回调
    onPrint: PropTypes.func, //打印报到单
};

export default AhgsXcfb;


// WEBPACK FOOTER //
// ./components/yxxc/steps/xcfb_ahgs.js